// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.circle {
  border-radius: 50%;
}

.with-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  max-height: 130px;
}

.no-shadow {
  box-shadow: none !important;
}

::ng-deep .mat-expansion-panel-body {
  padding: 0px !important;
  padding-left: 10px !important;
}

.bottom-to-top {
  border: 0px;
  border-right: 1px;
  border-style: solid;
  border-image: linear-gradient(to top, #c1c1c1, rgba(0, 0, 0, 0)) 1 100%;
}

.circle {
  border-radius: 50%;
}

.with-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  max-height: 130px;
}

.no-shadow {
  box-shadow: none !important;
}

::ng-deep .mat-expansion-panel-body {
  padding: 0px !important;
  padding-left: 10px !important;
}

.bottom-to-top {
  border: 0px;
  border-right: 1px;
  border-style: solid;
  border-image: linear-gradient(to top, #c1c1c1, rgba(0, 0, 0, 0)) 1 100%;
}

.bottom-img {
  display: block;
  max-height: 200px;
}

.bottom-img-wrapper {
  z-index: 1;
  position: fixed;
  bottom: 15px;
  right: 30px;
}


.my-overlay {
  left: 0 !important;
  top: 0 !important;
  z-index: 10000 !important;
  width: 100% !important;
  height: 100% !important;
  position: fixed !important;
  background-color: rgba(0,0,0,0.9) !important;
  cursor: pointer !important;
  visibility: visible !important;
  transition: visibility 0s, opacity 0.4s linear !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: wait !important;
}
.my-overlay i.fa.fa-spinner.fa-spin, .spinner-big {
  font-size: 100px !important;
}*/

.container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url('bg-central.png');
  background-color:#F1F1F2;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position-y: bottom;
}

.circle {
  border-radius: 50%;
}

.with-bg {
  /* background: url('') no-repeat center; */
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  max-height: 130px;
}

.no-shadow {
  box-shadow: none !important;
}

::ng-deep .mat-expansion-panel-body {
  padding: 0px !important;
  padding-left: 10px !important;
}

.bottom-to-top {
  border: 0px;
  border-right: 1px;
  border-style: solid;
  border-image: linear-gradient(to top, #c1c1c1, rgba(0, 0, 0, 0)) 1 100%;
}

mat-sidenav {
  width: 250px;
}

.circle {
  border-radius: 50%;
}

.with-bg {
  /* background: url('') no-repeat center; */
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  max-height: 130px;
}

.no-shadow {
  box-shadow: none !important;
}

::ng-deep .mat-expansion-panel-body {
  padding: 0px !important;
  padding-left: 10px !important;
}

.bottom-to-top {
  border: 0px;
  border-right: 0px;
  border-style: solid;
  border-image: linear-gradient(to top, #c1c1c1, rgba(0, 0, 0, 0)) 1 100%;
}

.sidemenu-back {
  background: url('bg-menu.png');
  background-color: #606062;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position-y: bottom;
}

.back-central{
  background: url('bg-central.png');
  background-color:#F1F1F2;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position-y: bottom;
  position: absolute !important;
  bottom: 0px;
  width: 100%;
  height: 100%;
}


`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAqGE;;AAEF;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iCAA+C;EAC/C,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uEAAuE;AACzE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uEAAuE;AACzE;;AAEA;EACE,8BAA4C;EAC5C,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iCAA+C;EAC/C,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,WAAW;EACX,WAAW;EACX,YAAY;AACd","sourcesContent":["/*.container {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n}\r\n\r\n.circle {\r\n  border-radius: 50%;\r\n}\r\n\r\n.with-bg {\r\n  overflow: hidden;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: -1;\r\n  max-height: 130px;\r\n}\r\n\r\n.no-shadow {\r\n  box-shadow: none !important;\r\n}\r\n\r\n::ng-deep .mat-expansion-panel-body {\r\n  padding: 0px !important;\r\n  padding-left: 10px !important;\r\n}\r\n\r\n.bottom-to-top {\r\n  border: 0px;\r\n  border-right: 1px;\r\n  border-style: solid;\r\n  border-image: linear-gradient(to top, #c1c1c1, rgba(0, 0, 0, 0)) 1 100%;\r\n}\r\n\r\n.circle {\r\n  border-radius: 50%;\r\n}\r\n\r\n.with-bg {\r\n  overflow: hidden;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: -1;\r\n  max-height: 130px;\r\n}\r\n\r\n.no-shadow {\r\n  box-shadow: none !important;\r\n}\r\n\r\n::ng-deep .mat-expansion-panel-body {\r\n  padding: 0px !important;\r\n  padding-left: 10px !important;\r\n}\r\n\r\n.bottom-to-top {\r\n  border: 0px;\r\n  border-right: 1px;\r\n  border-style: solid;\r\n  border-image: linear-gradient(to top, #c1c1c1, rgba(0, 0, 0, 0)) 1 100%;\r\n}\r\n\r\n.bottom-img {\r\n  display: block;\r\n  max-height: 200px;\r\n}\r\n\r\n.bottom-img-wrapper {\r\n  z-index: 1;\r\n  position: fixed;\r\n  bottom: 15px;\r\n  right: 30px;\r\n}\r\n\r\n\r\n.my-overlay {\r\n  left: 0 !important;\r\n  top: 0 !important;\r\n  z-index: 10000 !important;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  position: fixed !important;\r\n  background-color: rgba(0,0,0,0.9) !important;\r\n  cursor: pointer !important;\r\n  visibility: visible !important;\r\n  transition: visibility 0s, opacity 0.4s linear !important;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: wait !important;\r\n}\r\n.my-overlay i.fa.fa-spinner.fa-spin, .spinner-big {\r\n  font-size: 100px !important;\r\n}*/\r\n\r\n.container {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background: url(\"../assets/img/bg-central.png\");\r\n  background-color:#F1F1F2;\r\n  background-size: 100%;\r\n  background-repeat: no-repeat;\r\n  background-position-y: bottom;\r\n}\r\n\r\n.circle {\r\n  border-radius: 50%;\r\n}\r\n\r\n.with-bg {\r\n  /* background: url('') no-repeat center; */\r\n  overflow: hidden;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: -1;\r\n  max-height: 130px;\r\n}\r\n\r\n.no-shadow {\r\n  box-shadow: none !important;\r\n}\r\n\r\n::ng-deep .mat-expansion-panel-body {\r\n  padding: 0px !important;\r\n  padding-left: 10px !important;\r\n}\r\n\r\n.bottom-to-top {\r\n  border: 0px;\r\n  border-right: 1px;\r\n  border-style: solid;\r\n  border-image: linear-gradient(to top, #c1c1c1, rgba(0, 0, 0, 0)) 1 100%;\r\n}\r\n\r\nmat-sidenav {\r\n  width: 250px;\r\n}\r\n\r\n.circle {\r\n  border-radius: 50%;\r\n}\r\n\r\n.with-bg {\r\n  /* background: url('') no-repeat center; */\r\n  overflow: hidden;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: -1;\r\n  max-height: 130px;\r\n}\r\n\r\n.no-shadow {\r\n  box-shadow: none !important;\r\n}\r\n\r\n::ng-deep .mat-expansion-panel-body {\r\n  padding: 0px !important;\r\n  padding-left: 10px !important;\r\n}\r\n\r\n.bottom-to-top {\r\n  border: 0px;\r\n  border-right: 0px;\r\n  border-style: solid;\r\n  border-image: linear-gradient(to top, #c1c1c1, rgba(0, 0, 0, 0)) 1 100%;\r\n}\r\n\r\n.sidemenu-back {\r\n  background: url(\"../assets/img/bg-menu.png\");\r\n  background-color: #606062;\r\n  background-size: 100%;\r\n  background-repeat: no-repeat;\r\n  background-position-y: bottom;\r\n}\r\n\r\n.back-central{\r\n  background: url(\"../assets/img/bg-central.png\");\r\n  background-color:#F1F1F2;\r\n  background-size: 100%;\r\n  background-repeat: no-repeat;\r\n  background-position-y: bottom;\r\n  position: absolute !important;\r\n  bottom: 0px;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
